module.exports = __webpack_public_path__ + "img/user.dfc7e5b0.svg";